"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSelectedTooltipItems = exports.toggleSelectedTooltipItem = exports.pinTooltip = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.pinTooltip = (0, toolkit_1.createAction)('PIN_TOOLTIP', ({ pinned, resetPointer = false }) => ({
    payload: {
        pinned,
        resetPointer,
    },
}));
exports.toggleSelectedTooltipItem = (0, toolkit_1.createAction)('TOGGLE_SELECTED_TOOLTIP_ITEM');
exports.setSelectedTooltipItems = (0, toolkit_1.createAction)('SET_SELECTED_TOOLTIP_ITEMS');
//# sourceMappingURL=tooltip.js.map